import StudentKoruAccountPage from './StudentKoruAccountPage';
import { StudentKoruAccountPageProps, StudentKoruAccountPageValueProps } from './types';

export type { StudentKoruAccountPageProps, StudentKoruAccountPageValueProps };
export default StudentKoruAccountPage;
